// Plugins

// Local
import initUitKit from "./ui-kit.js";

window.initDom = ($wrapper) => {
    initUitKit($wrapper);
    $wrapper.querySelectorAll('[data-appointment-form]').forEach(async ($el) => {
        const AppointmentForm = await import('./partials/appointment/appointment-form');
        new AppointmentForm.default($el);
    });
    $wrapper.querySelectorAll('[data-location-list]').forEach(async ($el) => {
        const LocationList = await import('./partials/location-list');
        (new LocationList.default($el));
    });
}

(function() {
    window.initDom(document);
})();
